export const  enum PriceType {
  CostPerKg = 0,
  CostPerMetre = 1,
  CostPerTest = 2,
  CostPerCheck = 3
}

export const priceTypeOptions = [
  {priceTypeName: "Cost per kilogram", priceTypeValue: PriceType.CostPerKg},
  {priceTypeName: "Cost per metre", priceTypeValue: PriceType.CostPerMetre},
  {priceTypeName: "Cost per test", priceTypeValue: PriceType.CostPerTest},
  {priceTypeName: "Cost per check", priceTypeValue: PriceType.CostPerCheck},
]